import axios from "axios";

export const APILOG = (page_title, event, params) => {
  let payload = {};
  if (params) {
    payload = {
      page_title: page_title,
      event: event,
      ...params
    };
  } else {
    payload = {
      page_title: page_title,
      event: event,
    };
  }
  axios
    .post(process.env.REACT_APP_API_HOST + "/log", payload)
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};
